<template>
  <section>
    <div class="dashWrap">
      <div class="dashRow">
        <div class="dashBx">

          <div class="formInfo">
            <v-form ref="formUser">
              <dl class="infoCont">
                <dd class="formInfoArea d-flex">
                  <v-col class="mgr" sm="3">
                    <vue-dropzone
                        ref="userPhotoDropzone"
                        id="dropzone"
                        :options="dropzoneOptions"
                        :useCustomSlot="true"
                        @vdropzone-success="photoUploadSuccess"
                        @vdropzone-removed-file="photoRemove"

                    >

                      <div v-if="user.photoFile" style="margin-top: -40px">
                        <v-badge
                            bordered
                            dark
                            color="black"
                            icon="mdi-delete"
                            overlap
                            @click.native="photoRemove"
                        >
                          <img :src="`${attachFileServerUrl}/user/photo/${user.photoFile}`" style="max-height: 240px; max-width: 220px"/>
                        </v-badge>
                      </div>
                      <div class="dropzone-custom-content" v-else>
                        <h3 class="dropzone-custom-title">회원 사진</h3>
                        <div class="subtitle">Drag and drop or click to select a file from your computer</div>
                      </div>
                    </vue-dropzone>
                  </v-col>
                  <v-col class="mgr">
                    <v-row>
                      <v-col class="d-flex">
                        <v-text-field v-model="user.name" label="회원명 *" :rules="[rules.required]" flat dense></v-text-field>
                        <v-switch v-model="user.secManaged" :label="user.secManaged ? '삼성전자 관리 회원' : '전자사랑 회원'"
                                  disabled
                                  class="staff-switch-color" style="padding-left:15px; padding-top: 10px; padding-right:15px;"></v-switch>
                      </v-col>
                      <v-col class="d-flex">
                        <v-text-field v-model="user.userId" label="아이디 *" :rules="[rules.required]" flat dense :readonly="idReadOnly" :error-messages="errorMessages" :filled="idReadOnly" :style="idReadOnly ? 'margin-top: -11px' : 'margin-top: 0px'"></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col class="d-flex">
                        <v-menu
                            ref="birthPicker"
                            v-model="birthPicker"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                v-model="user.birthDate"
                                prepend-icon="mdi-calendar"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                                label="생년월일 *"
                                dense
                                flat
                            ></v-text-field>
                          </template>
                          <v-date-picker
                              ref="picker"
                              v-model="user.birthDate"
                              :max="new Date().toISOString().substr(0, 10)"
                              min="1930-01-01"
                              @change="datePick"
                              locale="ko-kr"
                          ></v-date-picker>
                        </v-menu>
                        <v-switch v-model="user.lunarBirth" :label="user.lunarBirth ? '음력' : '양력'" class="lunar-switch-color" style="padding-left:15px; padding-top: 10px; padding-right:15px;"></v-switch>
                      </v-col>
                      <v-col>
                        <v-text-field v-model="user.mobileNo" type="number" maxlength="11" :rules="[rules.required, rules.length11]"  dense flat label="연락처 *" :error-messages="errorMessagesMobile"/>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <v-text-field v-model="user.retirementDepartment" :rules="[rules.required]"  dense flat label="최종부서 (전자 재임시) *" />
                      </v-col>
                      <v-col>
                        <v-text-field v-model="user.retirementPosition" :rules="[rules.required]" dense flat label="직위 (전자 재임시) *"/>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <v-text-field v-model="user.retirementDate"  dense flat label="퇴임일 및 전출일"/>
                      </v-col>
                      <v-col>
                        <v-text-field v-model="user.email" :rules="[rules.required]" dense flat :error-messages="errorMessagesEmail" label="이메일 *"/>
                      </v-col>
                    </v-row>

                  </v-col>
                </dd>
              </dl>
              <dl class="infoCont">
                <dt class="formInfoTxt">주소 <i class="fa fa-asterisk" aria-hidden="true"/></dt>
                <dd class="formInfoArea">
                  <v-col class="d-flex">
                    <v-text-field type="number" v-model="user.zipCode" label="우편번호 *"
                                  @click="openZipCode"
                                  v-on:keyup.13="openZipCode"
                                  maxlength="6"
                                  :rules="[
                                              rules.required,
                                              value => !!value && value.length >= 5 && value.length <= 6 || '우편번호 형식이 아닙니다.\n\r5~6자리 숫자로 입력해주세요.'
                                              ]"
                                  style="max-width: 120px; padding-right: 10px"
                    />
                    <v-text-field v-model="user.address" :rules="[rules.required]" label="주소 *" style="padding-right: 10px"/>
                    <v-text-field v-model="user.addressDetail" :rules="[rules.required]" label="주소상세 *"/>
                    <v-dialog v-model="daumDialogVisible" max-width="500px" @click:outside="daumDialogVisible=false" @keydown.esc="daumDialogVisible=false">
                      <daum-post @complete="completeZipCode" />
                    </v-dialog>
                  </v-col>
                </dd>
              </dl>

              <dl class="infoCont">
                <dt class="formInfoTxt">현재 직장</dt>
                <dd class="formInfoArea">
                  <v-col>
                    <v-text-field v-model="user.company" dense flat />
                  </v-col>
                </dd>
                <dt class="formInfoTxt">현재 직책</dt>
                <dd class="formInfoArea">
                  <v-col>
                    <v-text-field v-model="user.position" dense flat />
                  </v-col>
                </dd>
              </dl>

              <dl class="infoCont">
                <dt class="formInfoTxt">이력</dt>
                <dd class="formInfoArea">
                  <v-textarea v-model="user.career" dense flat />
                </dd>
                <dt class="formInfoTxt">메모</dt>
                <dd class="formInfoArea">
                  <v-textarea v-model="user.memo" dense flat />
                </dd>
              </dl>
              <dl class="infoCont">
                <dt class="formInfoTxt">약관 동의 여부</dt>
                <dd class="formInfoArea">
                  <v-col class="d-flex">
                    <v-switch v-model="user.antiGraftLawTarget" label="청탁금지법 대상" :value="true" :false-value="false" style="padding-right: 20px"/>
                    <v-switch v-model="user.clauseAgreement" label="약관 동의 여부" :value="true" :false-value="false"  style="padding-right: 20px"/>
                    <v-switch v-model="user.personalInformationAgreement" label="개인정보 수집 및 이용에 동의" :value="true" :false-value="false" />
                  </v-col>
                </dd>
              </dl>
            </v-form>
          </div>
          <div class="btnStyleBx">
            <div class="btnCommon justify-center">

              <a @click="$router.go(-1)">
                <v-btn class="vBtn" color="#fafafa">
                  <v-icon left>mdi mdi-format-list-bulleted</v-icon>
                  목록
                </v-btn>
              </a>
              <v-btn class="vBtn" color="grey" dark @click="resetUser">
                <v-icon left>mdi mdi-reload</v-icon>
                취소
              </v-btn>
              <v-btn class="vBtn" color="success" :dark="user.secManaged" @click="saveUser()" :disabled="!user.secManaged">
                <v-icon left>mdi mdi-check</v-icon>
                저장
              </v-btn>
            </div>
          </div>

        </div>
      </div>
    </div>
  </section>
</template>
<script>
import userApi from "@/api/UserApi";
import secUserApi from "@/api/SecUserApi"

import _ from 'lodash';
import vue2Dropzone from 'vue2-dropzone'
// import { VueDaumPostcode } from "vue-daum-postcode"

export default {
  name: "UserForm",
  components: {
    vueDropzone: vue2Dropzone
  },
  props: {
    userId: String
    // item: Object
  },
  watch: {
    birthPicker (val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
    },
  },
  data: () => ({
    idReadOnly: false,
    daumDialogVisible: false,
    birthPicker: false,
    attachFileServerUrl: process.env.VUE_APP_ATTACH_FILE_SERVER_URL,
    user: {
      zipCode:'',
      address:'',
      lunarBirth: false,
      birthDate: '1960-01-01',
      secManaged: true
    },
    userInit: {},
    title:'회원 추가',
    rules: {
      required: value => (value && value.length > 0) || '필수 입력 항목입니다..',
      length11: value => value && value.length < 12 || '11자리 이하 숫자로만 입력 가능합니다..'
    },
    passwordCheck:'',
    isModify:false,
    errorMessages:'',
    errorMessagesMobile:'',
    errorMessagesEmail:''
  }),
  computed: {
    dropzoneOptions() {
      return {
        url: `${process.env.VUE_APP_BASE_API}/user/upload/image`,
        thumbnailWidth: 150,
        maxFilesize: 2, // mb
        maxFiles: 2,
        acceptedFileTypes: "image/*",
        headers: {
          'Authorization': `bearer ${this?.$store?.getters?.token ?? ''}`
        },
        uploadMultiple: false,
        clickable: true,
        addRemoveLinks: true
      }
    }
  },
  methods: {
    datePick(date) {
      this.$refs.birthPicker.save(date)
    },
    photoUploadSuccess(file, response) {
      this.user.photoFile = response.saveName;
      const acceptedFiles = this.$refs.userPhotoDropzone.getAcceptedFiles();
      if(acceptedFiles && acceptedFiles.length > 1)
        this.$refs.userPhotoDropzone.removeFile(acceptedFiles[0]);
    },
    photoRemove() {
      this.user.photoFile = null;
    },
    openZipCode() {
      this.daumDialogVisible = true;
    },
    completeZipCode(data) {
      this.user.zipCode = data.zonecode
      this.user.address = data.address
      this.daumDialogVisible = false;
    },
    async duplicatedUserIdCheck(userId) {
      if(userId) {
        const isUsed = await userApi.exists(userId)
        if (isUsed && userId !== this.userInit.userId) {
          this.errorMessages = '이미 사용중인 아이디입니다.';
          return false;
        }
        this.errorMessages = null;
        return true;
      }

      return false;
    },
    async duplicatedMobileNoCheck(mobileNo) {
      if(mobileNo) {
        const isUsed = await userApi.existsMobile(mobileNo)
        if (isUsed && mobileNo !== this.userInit.mobileNo) {
          this.errorMessagesMobile = '이미 등록된 연락처입니다.';
          return false;
        }
        this.errorMessagesMobile = null;
        return true;
      }

      return false;
    },
    async duplicatedEmailCheck(email) {
      if(email) {
        const isUsed = await userApi.existsEmail(email)
        if (isUsed && email  !== this.userInit.email) {
          this.errorMessagesEmail = '이미 등록된 이메일입니다.';
          return false;
        }
        this.errorMessagesEmail = null;
        return true;
      }

      return false;
    },
    async saveUser() {
      const valid = [await this.$refs.formUser.validate(), await this.duplicatedUserIdCheck(this.user.userId), await this.duplicatedMobileNoCheck(this.user.mobileNo), await this.duplicatedEmailCheck(this.user.email)];
      if(valid.indexOf(false) !== -1) {
        window.scrollTo(0,50);
        alert("입력 폼 유효성 검증에 실패했습니다. 입력 항목을 확인해주세요.")
        return;
      }

      try {
        // 아이디 모든 공백 제거
        this.user.userId = this.user.userId.replace(/(\s*)/g, "");
        secUserApi.save(this.user).then(() => {
          this.$refs.userPhotoDropzone.removeAllFiles();
          alert('저장되었습니다.');
          // this.$router.push('/sec/users/form/' + this.user.userId)
          this.$router.push('/sec/users')
        });

      } catch (error) {
        alert(error.response?.data?.message??'error');
        console.log(error);
      }
    },
    resetUser() {
      this.user = _.cloneDeep(this.userInit);
      this.idReadOnly = this.isModify;

      this.$refs?.userPhotoDropzone?.removeAllFiles();
      this.$refs?.formUser?.resetValidation();

    }
  },
  created() {

    if(!this.userId) {
      this.title = '회원 추가';
      this.isModify = false;
      this.userInit = _.cloneDeep(this.user);
    } else {
      secUserApi.get(this.userId).then(user => {
        this.user = user;

        this.$refs?.userPhotoDropzone?.removeAllFiles();

        this.$refs?.formUser?.resetValidation();
        // this.$refs?.formUser?.reset();

        this.user.originUserId = this.user.userId;
        this.userInit = _.cloneDeep(this.user);

      });

      this.title = '회원정보 수정';
      this.isModify = true;
      this.idReadOnly = true;
      this.user.password = '';
    }

    this.$refs?.userPhotoDropzone?.removeAllFiles();

  }
}
</script>

<style lang="scss">
@import '../../../assets/style/layout/variables';

.dropzone-custom-content {
  /*position: absolute;*/
  /*top: 50%;*/
  /*left: 50%;*/
  /*transform: translate(-50%, -50%);*/
  text-align: center;
}

.dropzone-custom-title {
  margin-top: 0;
  color: #00b782;
}

.subtitle {
  color: #314b5f;
}

.dropzone {
  min-height:260px;
  max-height:260px
}

.h2Title {
  @include h2-title;
}

.formInfo {
  @include form-info;
}

.formInfoTxt{
  max-width: 240px;
}

.userDd {
  padding: 10px 0;
}

.list {
  overflow: hidden;
}

.lunar-switch-color:not(.v-input--is-label-active) .v-input--selection-controls__input div {
  color: orange !important;
}
.staff-switch-color:not(.v-input--is-label-active) .v-input--selection-controls__input div {
  color: olivedrab !important;
}
</style>